import { resolveDateTimePickerProps } from '@/common/utils/resolveDateTimePickerProps'

/** Icon + padding reserve beyond character width (px). */
const DATE_TIME_ICON_RESERVE_PX = 36

/**
 * Minimum CSS width for DateTime inputs from platform `format`
 */
export function resolveDateTimeFieldMinWidth(rawFormat: unknown): string {
  const props = resolveDateTimePickerProps(rawFormat)
  if (props.timeOnly) {
    return `calc(5.5ch + ${DATE_TIME_ICON_RESERVE_PX}px)`
  }
  if (props.showTime && !props.timeOnly) {
    return `calc(14ch + ${DATE_TIME_ICON_RESERVE_PX}px)`
  }
  return `calc(10.5ch + ${DATE_TIME_ICON_RESERVE_PX}px)`
}

/**
 * Minimum grid column share (%) for DateTime cells by format.
 */
export function resolveDateTimeMinColPct(rawFormat: unknown): number {
  const format = String(rawFormat ?? '').trim()
  const cleaned = format.replace(/'[^']*'/g, '')
  const props = resolveDateTimePickerProps(rawFormat)
  if (props.timeOnly) {
    if (/s{1,2}/.test(cleaned)) return 14
    return 9
  }
  if (props.showTime && !props.timeOnly) return 13
  return 18
}
